import { AxiosResponse } from "axios";
import axiosClient from "@/services/api/index";

export default {
  getLotsReports(estateId: string): Promise<AxiosResponse> {
    return axiosClient.get(`/v2/reports/lots/${estateId}`);
  },
  getStagesReports(estateId: string): Promise<AxiosResponse> {
    return axiosClient.get(`/v2/reports/stages/${estateId}`);
  },
  getLotsAuditLogs(estateId: string): Promise<AxiosResponse> {
    return axiosClient.get(`/v2/reports/audit/lot/${estateId}`);
  },
  exportReport(payload: Record<string, unknown>): Promise<AxiosResponse> {
    return axiosClient.post(`/v2/reports/export`, payload);
  },
};
